export default {
  // #region Danh mục
  Asset: 'di_asset',
  AccountingObject: 'di_accounting_object',
  JusticeDecision: 'di_justice_decision',
  Stock: 'di_stock',
  Area: 'di_area',
  // #region Tài khoản
  AutoBusiness: 'di_auto_business', // Định khoản tự động
  AccountParallelRule: 'di_account_parallel_rule', // quy tắc hạch toán đồng thời
  AccountTransfer: 'di_account_transfer', // danh mục tk kết chuyển
  AccountBalance: 'di_account_balance', // số dư tài khoản
  SystemAccount: 'di_account', // TK hệ thống
  DefaultAccount: 'ref_type', // danh mục tk ngầm định
  // #endregion

  // #region Mục lục ngân sách
  BudgetProvide: 'di_budget_provide',
  BudgetSourceProperty: 'di_budget_source_property',
  // #endregion

  // #region  Danh mục Khác
  Activity: 'di_activity',
  FundStructure: 'di_fund_structure',

  ProjectBudget: 'di_project_budget_detail',

  // Danh mục vật tư hàng hóa
  InventoryItem: 'di_inventory_item',

  // Danh mục công cụ dụng cụ
  InventoryItemTools: 'di_inventory_item_tool',

  // Danh mục Mã thống kê
  Statistic: 'di_statistic',
  // Danh mục Mã thống kê
  BankInfo: 'di_bank_info',

  // Danh mục Thôn xóm
  Hamlet: 'di_hamlet',
  // Danh mục Cán bộ
  AccountingObjectCb: 'di_accounting_object_cb',
  // Danh mục Tài sản cố định
  FixedAsset: 'di_fixed_asset',
  // Danh mục chương trình mục tiêu, dự án
  Project: 'di_project',
  // Danh mục nguồn kinh phí
  BudgetSource: 'di_budget_source',
  // Danh mục CTMTDA
  Project: 'di_project',

  // #endregion

  // #region Chứng từ

  // Séc
  Cheque: '40',
  // Phiếu nộp tiền vào tài khoản
  Deposit: '41',
  // Phiếu thu
  CaCashReceipt: '20',
  // Phiếu chi
  CaCashPayment: '21',
  // Phiếu xác định tiền, giá trị TSTV
  AssetEvaluation: '98',
  // Chứng từ nghiệp vụ khác
  GeneralJournalEntry: '80',
  // Phiếu kết chuyển tài khoản
  AccountTransferSlipVoucher: '70',
  // Phân phối thu thi hành án
  JusticeReceiptAllocation: '71',
  // Phân phối tiền bán tài sản
  JusticeSellingAllocation: '72',
  // Phiếu kết chuyển tài khoản
  SUAccountTransfer: '101',

  // Chứng từ ghi đồng thời
  ParallelVoucher: '106',

  // Tiền gửi - Chi tiền gửi
  CashDeposit: '30',
  // Tiền gửi - Thu tiền gửi
  BAWithDraw: '33',
  // DTNS - Dự toán giữ lại
  BUBudgetReserve: '44',
  // Chuyển kho
  AssetTransfer: '62',
  // Nhập mua bằng tiền gửi
  InventoryInwardDeposit: '63',
  // Phiếu nhập kho
  InwardStock: '60',
  // Phiếu xuất kho
  OutwardStock: '61',
  // Kiểm kê
  Inventory: '120',

  // #endregion

  // #region
  // Khác
  // nhập số dư đầu kỳ
  InitialBalance: 'initial_balance',
  // biên lai
  Ticket: 'ticket',
  // #endregion
};
